const RainbowConnection = [
	'[Verse 1]',
	'Why are there so many songs about rainbows,',
	"and what's on the other side?",
	'Rainbows are visions, but only illusions.',
	'Rainbows have nothing to hide.',
	'',
	'[Pre-chorus 1]',
	"So we've been told and some choose to believe it.",
	"I know they're wrong, wait and see.",
	'',
	'[Chorus]',
	"Someday we'll find it, the rainbow connection.",
	'The lovers, the dreamers, and me.',
	'',
	'[Verse 2]',
	'Who said that every wish would be heard and answered',
	'and wished on a morning star?',
	'Somebody thought of that and someone believed him.',
	"Look what it's done so far.",
	'',
	'[Pre-chorus 2]',
	"What's so amazing and keeps us stargazing?",
	'What do we think we might see?',
	'',
	'[Chorus]',
	"Someday we'll find it, the rainbow connection.",
	'The lovers, the dreamers and me.',
	'',
	'[Verse 3]',
	'Have you been half asleep and have you heard voices?',
	"I've heard them calling my name.",
	'Are these the sweet sounds that called the young sailors?',
	"I think they're one and the same.",
	'',
	'[Pre-chorus 3]',
	"I've heard it too many times to ignore it.",
	"It's something that I'm supposed to be.",
	'',
	'[Chorus]',
	"Someday we'll find it, the rainbow connection.",
	'The lovers, the dreamers and me.',
];

export default RainbowConnection;
